/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerGetContactsQueryResponse,
  TelegramProductsUserControllerGetContactsPathParams,
  TelegramProductsUserControllerGetContactsQueryParams,
  TelegramProductsUserControllerGetContacts401,
} from '../types/TelegramProductsUserControllerGetContacts.ts';

function getTelegramProductsUserGetContactsUrl(link: TelegramProductsUserControllerGetContactsPathParams['link']) {
  const res = { method: 'GET', url: `/api/user/telegram/products/${link}/contacts` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/:link/contacts}
 */
export async function telegramProductsUserGetContacts(
  link: TelegramProductsUserControllerGetContactsPathParams['link'],
  params?: TelegramProductsUserControllerGetContactsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsUserControllerGetContactsQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerGetContacts401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsUserGetContactsUrl(link).url.toString(), params, ...requestConfig });
  return res.data;
}
